import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4","key":"svg-0"}]]

const IconCornerRightDown = createReactComponent('outline', 'corner-right-down', 'CornerRightDown', __iconNode);

export default IconCornerRightDown;